import React from "react";
import { View } from "react-native";
import { Text } from "../../../../components/Text";
import { headerStyles as styles } from "./styles";
import { Order } from "@/app/types/order";
import { translateNumber, useTranslateText } from "@/app/utils/translations";
import { formatDate, getLineItemCount } from "@/app/utils/orderHistory";
import { formatMoney } from "@/app/utils/currency";

type HeaderProps = {
  order: Order;
};

const Header = ({ order }: HeaderProps): JSX.Element => {
  const { locale, t } = useTranslateText();
  const date = formatDate(order.createdAt);
  const lineItemCount = getLineItemCount(order);
  const orderNumber = translateNumber(order.albaikIdentifier, locale);
  const orderPin = translateNumber(order.backupPin, locale);

  return (
    <View style={styles.container}>
      <Text style={styles.timeText}>{date}</Text>
      <View style={styles.rowContainer}>
        <Text style={styles.rowBoldText}>
          {`${t("orderScreen.orderNumber")} ${orderNumber}`}
        </Text>
        <Text style={styles.rowBoldText}>
          {`${t("tpos.orderHistoryArea.pin")} ${orderPin}`}
        </Text>
      </View>
      <View style={styles.rowContainer}>
        <Text style={styles.rowText}>
          {`${lineItemCount} ${t("tpos.basketArea.items")}`}
        </Text>
        <Text style={styles.rowText}>
          {formatMoney(order.total, true, locale).amount}
        </Text>
      </View>
    </View>
  );
};

export default Header;
